import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ o("path", { d: "m33.466 25.918 1.13-7.364H27.53v-4.778c0-2.015.987-3.979 4.151-3.979h3.213v-6.27s-2.916-.497-5.703-.497c-5.82 0-9.623 3.527-9.623 9.912v5.612H13.1v7.364h6.468v17.803a25.667 25.667 0 0 0 7.962 0V25.918h5.936Z" }, null, -1), r = [
  n
];
function s(h, d) {
  return e(), t("svg", c, r);
}
const v = { render: s };
export {
  v as default,
  s as render
};
//# sourceMappingURL=facebook.svg.mjs.map
